import { cloneElement } from "react";

const ConditionalWrapper = ({ condition, Wrapper, children }) => {
  return condition ? cloneElement(Wrapper, { children }) : children
}

export default ConditionalWrapper;
